import { useState, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import SectionLabel from './SectionLabel'
import TrekCard from './TrekCard'
import { treks } from '../data/treks'

export default function TreksSection() {
  const featured = treks.filter(t => t.featured)
  const difficulties = ['All', ...Array.from(new Set(featured.map(t => t.difficulty)))]
  const [active, setActive] = useState('All')
  const rowRef = useRef(null)
  const [searchParams] = useSearchParams()
  const q = (searchParams.get('q') || '').toLowerCase().trim()

  const byQuery = q
    ? featured.filter(t => `${t.name} ${t.tagline} ${t.description}`.toLowerCase().includes(q))
    : featured
  const filtered = active === 'All' ? byQuery : byQuery.filter(t => t.difficulty === active)

  const scroll = dir => rowRef.current?.scrollBy({ left: dir * 320, behavior: 'smooth' })

  return (
    <section id="treks" className="section" style={{ background: 'var(--white)' }}>
      <SectionLabel>Our Flagship Treks</SectionLabel>
      <h2 className="section-title">The heart of Nepal.</h2>
      <p className="section-sub">
        Solitude, culture, and high altitude. These are the routes we know better than anyone else.
      </p>

      {q && (
        <p style={{ fontSize: '13px', color: 'var(--ink-light)', marginBottom: '16px' }}>
          Showing results for "{q}"
        </p>
      )}

      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '24px' }}>
        {difficulties.map(d => (
          <button
            key={d}
            className={`pill-tab ${active === d ? 'active' : ''}`}
            onClick={() => setActive(d)}
          >
            {d}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button className="scroll-arrow" onClick={() => scroll(-1)} aria-label="Previous">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div ref={rowRef} className="scroll-row" style={{ flex: 1 }}>
          {filtered.map((t, i) => (
            <div key={t.id} className="scroll-row-item" style={{ width: '300px' }}>
              <TrekCard trek={t} index={i} />
            </div>
          ))}
        </div>
        <button className="scroll-arrow" onClick={() => scroll(1)} aria-label="Next">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </section>
  )
}
